"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * 视频的dash相关信息
 */
var Manifest =
/**
 *
 * @param selectorString
 * @param url
 * @param mimeType
 * @param initRange
 * @param indexRange
 */
function Manifest(selectorString, url, mimeType, initRange, indexRange) {
    _classCallCheck(this, Manifest);

    this.videoDom = document.querySelector(selectorString);
    this.SegmentUrl = url;
    this.VideoMimeType = mimeType;
    this.SegmentSIDX = {
        IndexRange: indexRange
    };
    this.Initialization = {
        InitRange: initRange
    };
};

exports.default = Manifest;


//////////////////
// WEBPACK FOOTER
// ./~/somi-dashjs/dist/Manifest.js
// module id = 18
// module chunks = 0